import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ROOM_TYPE } from "../../common/constants/classifications"
import './search_condition.scss'
import CouponHelper from '../../common/helpers/coupon_helper'

/**
 *  こだわり条件で絞り込みコンポーネント
 */
export default class SearchConditions extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isSearchCondVisible: true,
      ...props.query
    }

    this.t = this.props.t
    this.onRadioChange = this.onRadioChange.bind(this)
    this.onCheckboxChange = this.onCheckboxChange.bind(this)
  }

  static propTypes = {
    query: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  /**
   * radioのチェンジイベントをハンドルする
   */
  onRadioChange({ target: { name, value } }) {
    this.setState({ [name]: value || undefined })
    this.props.onChange({ ...this.queryFromState, [name]: value || undefined })
  }

  /**
   * checkboxのチェンジイベントをハンドルする
   */
  onCheckboxChange({ target: { name, value } }) {
    const values = Array.from(document.querySelectorAll(`[name="${name}"]:checked`)).map(i => i.value)
    this.setState({ [name]: values })
    this.props.onChange({ ...this.queryFromState, [name]: values })
  }

  componentDidUpdate({ query }) {
    if (JSON.stringify(query) !== JSON.stringify(this.props.query)) {
      this.setState({
        isSearchCondVisible: this.state.isSearchCondVisible,
        ...this.props.query
      })
    }
  }

  get queryFromState() {
    const {
      property_types: propertyTypes,
      room_types: roomTypes,
      coupon_id: couponId,
      disinfection_measure_codes: disinfectionMeasureCodes,
      amenities: amenitiesList,
      instant,
      house_rules: houseRules
    } = this.state

    return {
      property_types: propertyTypes,
      room_types: roomTypes,
      coupon_id: couponId,
      disinfection_measure_codes: disinfectionMeasureCodes,
      amenities: amenitiesList,
      instant,
      house_rules: houseRules
    }
  }

  renderPropertyTypeList() {
    const propertyTypes = [].concat(
      this.state['property_types[]'] || this.state.property_types || []
    )

    return (
      <div styleName="form-wrapper">
        <dl styleName="form-group">
          <dt styleName="form-group-title">{this.t('search.search_conditions.filter.accommodation_type.title')}</dt>
          <dd key="apartment">
            <input
              id="apartment"
              name="property_types"
              type="checkbox"
              styleName="n-check"
              value="apartment"
              onChange={this.onCheckboxChange}
              checked={propertyTypes.includes("apartment")}
            />
            <label
              styleName="n-check-label"
              htmlFor="apartment"
            >
              {this.t('search.search_conditions.filter.accommodation_type.apartment')}
            </label>
          </dd>
          <dd key="house">
            <input
              id="house"
              name="property_types"
              type="checkbox"
              styleName="n-check"
              value="house"
              onChange={this.onCheckboxChange}
              checked={propertyTypes.includes("house")}
            />
            <label
              styleName="n-check-label"
              htmlFor="house"
            >
              {this.t('search.search_conditions.filter.accommodation_type.house')}
            </label>
          </dd>
          { this.props.countryCode != 'vn' &&
            <Fragment>
              <dd key="hotel">
                <input
                  id="hotel"
                  name="property_types"
                  type="checkbox"
                  styleName="n-check"
                  value="hotel"
                  onChange={this.onCheckboxChange}
                  checked={propertyTypes.includes("hotel")}
                />
                <label
                  styleName="n-check-label"
                  htmlFor="hotel"
                >
                  {this.t('search.search_conditions.filter.accommodation_type.hotel')}
                </label>
              </dd>
              <dd key="bungalow">
                <input
                  id="bungalow"
                  name="property_types"
                  type="checkbox"
                  styleName="n-check"
                  value="bungalow"
                  onChange={this.onCheckboxChange}
                  checked={propertyTypes.includes("bungalow")}
                />
                <label
                  styleName="n-check-label"
                  htmlFor="bungalow"
                >
                  {this.t('search.search_conditions.filter.accommodation_type.bungalow')}
                </label>
              </dd>
              <dd key="cottage">
                <input
                  id="cottage"
                  name="property_types"
                  type="checkbox"
                  styleName="n-check"
                  value="cottage"
                  onChange={this.onCheckboxChange}
                  checked={propertyTypes.includes("cottage")}
                />
                <label
                  styleName="n-check-label"
                  htmlFor="cottage"
                >
                  {this.t('search.search_conditions.filter.accommodation_type.lodge')}
                </label>
              </dd>
              <dd key="glamping">
                <input
                  id="glamping"
                  name="property_types"
                  type="checkbox"
                  styleName="n-check"
                  value="glamping"
                  onChange={this.onCheckboxChange}
                  checked={propertyTypes.includes("glamping")}
                />
                <label
                  styleName="n-check-label"
                  htmlFor="glamping"
                >
                  {this.t('search.search_conditions.filter.accommodation_type.glamping')}
                </label>
              </dd>
            </Fragment> }
        </dl>
      </div>
    )
  }

  renderRoomTypeList() {
    // 旧パラメータ名が単数形になっているため、単数形・複数形どちらも対応
    const roomTypes = this.state.room_types || this.state.room_type

    return (
      <div styleName="form-wrapper">
        <dl styleName="form-group">
          <dt styleName="form-group-title">{this.t('search.search_conditions.filter.room_type.title')}</dt>
          <dd>
            <input
              id="room-type-0"
              name="room_types"
              type="radio"
              styleName="n-radio"
              value=""
              onChange={this.onRadioChange}
              checked={!roomTypes}
            />
            <label
              styleName="n-radio-label"
              htmlFor="room-type-0"
            >
              {this.t('search.search_conditions.filter.all')}
            </label>
          </dd>
          <dd>
            <input
              id="room-type-1"
              styleName="n-radio"
              name="room_types"
              type="radio"
              value={ROOM_TYPE.ENTIRE_HOME}
              onChange={this.onRadioChange}
              checked={roomTypes === ROOM_TYPE.ENTIRE_HOME}
            />
            <label
              styleName="n-radio-label"
              htmlFor="room-type-1"
            >
              {this.t('search.search_conditions.filter.room_type.entire')}
            </label>
          </dd>
          <dd>
            <input
              id="room-type-2"
              styleName="n-radio"
              name="room_types"
              type="radio"
              value={ROOM_TYPE.PRIVATE_ROOM}
              onChange={this.onRadioChange}
              checked={roomTypes === ROOM_TYPE.PRIVATE_ROOM}
            />
            <label
              styleName="n-radio-label"
              htmlFor="room-type-2"
            >
              {this.t('search.search_conditions.filter.room_type.private')}
            </label>
          </dd>
        </dl>
      </div>
    )
  }

  renderInstantTypeList() {
    const { instant } = this.state
    return (
      <div styleName="form-wrapper">
        <dl styleName="form-group">
          <dt styleName="form-group-title">{this.t('search.search_conditions.filter.reservation_type.title')}</dt>
          <dd>
            <input
              id="instantType_0"
              styleName="n-radio"
              name="instant"
              type="radio"
              value=""
              onChange={this.onRadioChange}
              checked={!instant}
            />
            <label
              styleName="n-radio-label"
              htmlFor="instantType_0"
            >
              {this.t('search.search_conditions.filter.all')}
            </label>
          </dd>
          <dd>
            <input
              id="instantType_1"
              styleName="n-radio"
              name="instant"
              type="radio"
              value="1"
              onChange={this.onRadioChange}
              checked={!!instant}
            />
            <label
              styleName="n-radio-label"
              htmlFor="instantType_1"
            >
              {this.t('search.search_conditions.filter.reservation_type.instant')}
            </label>
          </dd>
        </dl>
      </div>
    )
  }

  renderExtraConditions() {
    const couponIds = [].concat(
      this.state['coupon_id[]'] || this.state.coupon_id || []
    )
    const disinfectionMeasureCodes = [].concat(
      this.state['disinfection_measure_codes[]'] || this.state.disinfection_measure_codes || []
    )
    const amenitiesList = [].concat(
      this.state['amenities[]'] || this.state.amenities || []
    )
    const houseRules = [].concat(
      this.state['house_rules[]'] || this.state.house_rules || []
    )

    return (
      <div styleName="form-wrapper">
        <dl styleName="form-group">
          {this.props.coupons && this.props.coupons.map(coupon => (
            <dd key={coupon.id}>
              <input
                id={`coupon-${coupon.id}`}
                name="coupon_id"
                type="checkbox"
                styleName="n-check"
                value={coupon.id.toString()}
                onChange={this.onCheckboxChange}
                checked={couponIds.includes(coupon.id.toString())}
              />
              <label
                styleName="n-check-label"
                htmlFor={`coupon-${coupon.id}`}
              >
                { CouponHelper.translateName(coupon.title, this.props.lang, 'search_condition') }
              </label>
            </dd>
          ))}
          <dd>
            <input
              id="disinfection-measure-codes"
              name="disinfection_measure_codes"
              type="checkbox"
              styleName="n-check"
              value="ANY"
              onChange={this.onCheckboxChange}
              checked={disinfectionMeasureCodes.includes('ANY')}
            />
            <label
              styleName="n-check-label"
              htmlFor="disinfection-measure-codes"
            >
              {this.t('search.search_conditions.filter.extra.covid')}
            </label>
          </dd>
          <dd>
            <input
              id="kitchen"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="kitchen"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('kitchen')}
            />
            <label
              styleName="n-check-label"
              htmlFor="kitchen"
            >
              {this.t('search.search_conditions.filter.extra.kitchen')}
            </label>
          </dd>
          <dd>
            <input
              id="washer"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="washer"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('washer')}
            />
            <label
              styleName="n-check-label"
              htmlFor="washer"
            >
              {this.t('search.search_conditions.filter.extra.washer')}
            </label>
          </dd>
          <dd>
            <input
              id="dryer"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="dryer"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('dryer')}
            />
            <label
              styleName="n-check-label"
              htmlFor="dryer"
            >
              {this.t('search.search_conditions.filter.extra.dryer')}
            </label>
          </dd>
          <dd>
            <input
              id="refrigerator"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="refrigerator"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('refrigerator')}
            />
            <label
              styleName="n-check-label"
              htmlFor="refrigerator"
            >
              {this.t('search.search_conditions.filter.extra.refrigerator')}
            </label>
          </dd>
          <dd>
            <input
              id="micro_wave_oven"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="micro_wave_oven"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('micro_wave_oven')}
            />
            <label
              styleName="n-check-label"
              htmlFor="micro_wave_oven"
            >
              {this.t('search.search_conditions.filter.extra.microwave')}
            </label>
          </dd>
          <dd>
            <input
              id="tv"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="tv"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('tv')}
            />
            <label
              styleName="n-check-label"
              htmlFor="tv"
            >
              {this.t('search.search_conditions.filter.extra.tv')}
            </label>
          </dd>
          <dd>
            <input
              id="wifi"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="wifi"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('wifi')}
            />
            <label
              styleName="n-check-label"
              htmlFor="wifi"
            >
              {this.t('search.search_conditions.filter.extra.wifi')}
            </label>
          </dd>
          <dd>
            <input
              id="working_desk"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="working_desk"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('working_desk')}
            />
            <label
              styleName="n-check-label"
              htmlFor="working_desk"
            >
              {this.t('search.search_conditions.filter.extra.desk')}
            </label>
          </dd>
          <dd>
            <input
              id="hot_spring"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="hot_spring"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('hot_spring')}
            />
            <label
              styleName="n-check-label"
              htmlFor="hot_spring"
            >
              {this.t('search.search_conditions.filter.extra.hot_spring')}
            </label>
          </dd>
          <dd>
            <input
              id="sauna"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="sauna"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('sauna')}
            />
            <label
              styleName="n-check-label"
              htmlFor="sauna"
            >
              {this.t('search.search_conditions.filter.extra.sauna')}
            </label>
          </dd>
          <dd>
            <input
              id="bbq"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="bbq"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('bbq')}
            />
            <label
              styleName="n-check-label"
              htmlFor="bbq"
            >
              {this.t('search.search_conditions.filter.extra.bbq')}
            </label>
          </dd>
          <dd>
            <input
              id="pet"
              name="house_rules"
              type="checkbox"
              styleName="n-check"
              value="pet"
              onChange={this.onCheckboxChange}
              checked={houseRules.includes('pet')}
            />
            <label
              styleName="n-check-label"
              htmlFor="pet"
            >
              {this.t('search.search_conditions.filter.extra.pet')}
            </label>
          </dd>
          <dd>
            <input
              id="parking"
              name="amenities"
              type="checkbox"
              styleName="n-check"
              value="parking"
              onChange={this.onCheckboxChange}
              checked={amenitiesList.includes('parking')}
            />
            <label
              styleName="n-check-label"
              htmlFor="parking"
            >
              {this.t('search.search_conditions.filter.extra.parking')}
            </label>
          </dd>
        </dl>
      </div>
    )
  }

  render() {
    const hide = !this.state.isSearchCondVisible ? 'hide' : ''
    return (
      <div
        className="search-condition-wrap"
        styleName={`search-condition-wrap ${hide}`}
      >
        <div
          styleName="search-condition-header"
          onClick={() => this.setState(({ isSearchCondVisible }) => ({ isSearchCondVisible: !isSearchCondVisible }))}
        >
          <h2 styleName="toggleBtn">{this.t('search.search_conditions.filter.title')}</h2>
          <span styleName="plus-icon" />
        </div>
        <div styleName="search-condition-container">
          {/* 宿泊施設タイプ */}
          {this.renderPropertyTypeList()}
          {/* 部屋タイプ */}
          {this.renderRoomTypeList()}
          {/* 予約タイプ */}
          {this.renderInstantTypeList()}
          {/* クーポン・感染症対策・アメニティ・ハウスルール */}
          {this.renderExtraConditions()}
        </div>
      </div>
    )
  }
}
